// Window events the phone pages send to the layout, which owns what they open.

// Home's setup chip asks the layout, which owns the onboarding wizard, to
// reopen it where setup stopped.
export const OPEN_SETUP_EVENT = 'phone:opensetup';

// A page that does not import the phone shell (the statement checkup) asks it
// to open a movement's sheet: `detail.id` is the movement.
export const OPEN_MOVEMENT_EVENT = 'phone:openmovement';
